import React from "react";
import { Box } from "@mui/material";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import styled from "@emotion/styled";

const StyledDatePicker = styled(ReactDatePicker)``;

const DatePickerWrapper = styled(Box)`
  .react-datepicker {
    font-family: inherit;
    border: none;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }

  .react-datepicker__header {
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 8px 8px 0 0;
  }

  .react-datepicker__day {
    border-radius: 4px;

    &:hover {
      background-color: rgba(44, 52, 123, 0.1);
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-range {
    background-color: #2c347b;
    color: #fff;

    &:hover {
      background-color: #3f49a7;
    }
  }

  .react-datepicker__day--in-selecting-range {
    background-color: rgba(44, 52, 123, 0.2);
  }
`;

const DatePicker = ({ value, onChange, onClose, mode = "single", minDate,maxDate }) => {
  const handleChange = (dates) => {
    if (mode === "single") {
      const adjustedDate = dates ? new Date(dates.setHours(12, 0, 0, 0)) : null;
      onChange(adjustedDate);
      onClose?.();
    } else {
      const [start, end] = dates;
      if (start && end) {
        const adjustedStart = start ? new Date(start.setHours(12, 0, 0, 0)) : null;
        const adjustedEnd = end ? new Date(end.setHours(12, 0, 0, 0)) : null;
        onChange([adjustedStart, adjustedEnd]);
        onClose?.();
      } else {
        onChange(dates);
      }
    }
  };

  return (
    <DatePickerWrapper>
      <StyledDatePicker
        selected={
          mode === "single" ? value : Array.isArray(value) ? value[0] : null
        }
        onChange={handleChange}
        startDate={mode === "single" ?new Date():Array.isArray(value) && value[0] ? value[0] : null}
        endDate={mode === "range" && Array.isArray(value) ? value[1] : null}
        selectsRange={mode === "range"}
        inline
        dateFormat="yyyy-MM-dd"
        calendarStartDay={1}
        showPopperArrow={false}
        monthsShown={1}
        fixedHeight
        minDate={minDate != undefined ? minDate : null}
        maxDate={maxDate != undefined ? maxDate : null}
      />
    </DatePickerWrapper>
  );
};

export default DatePicker;
